import React from 'react'
import { useScreenSize } from '@navent-jobs/ui-kit/hooks/screen-size'
import Logo from './components/Logo'
import BackButton from './components/BackButton'
import ApplicantsLink from './components/ApplicantsLink'
import { CenterContent, LeftContent, RightContent } from './mixins'

const Component = () => {
  const { isMobile } = useScreenSize()

  return (
    <>
      <LeftContent minSize={isMobile}>
        <BackButton />
      </LeftContent>
      <CenterContent rightGutter={isMobile}>
        <Logo />
      </CenterContent>
      {!isMobile && (
        <RightContent>
          <ApplicantsLink />
        </RightContent>
      )}
    </>
  )
}

export default Component
